export default __webpack_public_path__ + "static/media/79.3c20d617.jpeg";